module.exports = __webpack_public_path__ + "img/cool.7e8cdfdf.jpg";